import React, { useState } from 'react';
import type { TrustAvatarSlot } from '../../../utils/publicTrust/publicTrustCopy.ts';
import TrustAvatar from './TrustAvatar.tsx';
import styles from './PublicTrustSnapshotCard.module.scss';

type TrustAvatarSlotProps = {
  slot: TrustAvatarSlot;
  popoverAlign?: 'start' | 'center' | 'end';
};

const TrustAvatarSlotInteractive: React.FC<TrustAvatarSlotProps> = ({
  slot,
  popoverAlign = 'center',
}) => {
  const [active, setActive] = useState(false);
  const alignClass =
    popoverAlign === 'end'
      ? styles.popoverAlignEnd
      : popoverAlign === 'start'
        ? styles.popoverAlignStart
        : styles.popoverAlignCenter;

  const metaParts = [slot.zone, slot.relativeDate].filter(Boolean);

  return (
    <div
      className={`${styles.avatarSlot} ${alignClass} ${active ? styles.avatarSlotActive : ''}`}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      onFocus={() => setActive(true)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
          setActive(false);
        }
      }}
      tabIndex={0}
      role="button"
      aria-label={`${slot.displayName}, ${slot.serviceTitle}`}
    >
      <TrustAvatar src={slot.stackImage} alt="" className={styles.avatar} />
      <div className={styles.avatarPopover} role="tooltip">
        <div className={styles.popoverHeader}>
          <TrustAvatar src={slot.profileImage} alt="" className={styles.popoverAvatar} />
          <div className={styles.popoverHeaderText}>
            <p className={styles.popoverName}>{slot.displayName}</p>
            {slot.categoryName ? (
              <span className={styles.popoverCategory}>{slot.categoryName}</span>
            ) : null}
          </div>
        </div>
        <p className={styles.popoverService}>{slot.serviceTitle}</p>
        {metaParts.length > 0 ? <p className={styles.popoverMeta}>{metaParts.join(' · ')}</p> : null}
      </div>
    </div>
  );
};

export default TrustAvatarSlotInteractive;
